import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getfloorDatabyStaus } from "../store/actions/floorActions";
import "./building_page.css";

const TABLE_HEAD = ["Floor Number", "Unit Number", "SQFT", "Status"];

const buttonLabels = {
  Button1: 5,
  Button2: 6,
  Button3: 7,
  Button4: 8,
  Button5: 9,
  Button6: 10,
  Button7: 11,
  Button8: 12,
  Button9: 14,
  Button10: 15,
};

export default function Availability2() {
  const [selectedButton, setSelectedButton] = useState("Button1");
  const floorData = useSelector((state) => state.floor.list);
  const dispatch = useDispatch();

  const imageButtonClick = (event) => {
    setSelectedButton(event.target.name);
  };

  const floorNum = buttonLabels[selectedButton];

  useEffect(() => {
    dispatch(getfloorDatabyStaus({ floorNum, status: "all" }));
  }, [selectedButton, dispatch, floorNum]);

  const getButtonClass = (buttonName) => {
    const baseClass =
      "w-1/5 max-w-[281px] min-w-[110px] px-4 py-2 font-semibold text-white border border-gray-dark rounded-[10px] transition-colors duration-300";
    const activeClass = "bg-[#ad885d] text-white border-[#333f48]";
    const inactiveClass =
      "bg-[#333f48] hover:bg-[#ad885d] hover:text-white hover:border-[#7e6140]";

    return `${baseClass} ${
      selectedButton === buttonName ? activeClass : inactiveClass
    }`;
  };

  return (
    <>
      <div className="flex w-full flex-col bg-[#F0EDE8] py-32">
        <div className="w-full text-[#00000] text-base">
          <section className="w-full md:flex">
            <div className="w-full flex bg-[#F0EDE8] -mt-4 md:-mt-0">
              <div className="w-full max-w-[920px] mx-auto md:py-[60px] pb-8 pt-10 md:text-center px-4">
                <p className="text-[#7e6140] text-4xl md:text-5xl font-normal leading-snug pb-1 md:pb-3">
                  Availability
                </p>
                <p>
                  Located in the heart of Flushing&apos;s vibrant downtown
                  business district, Union Center presents a 133,000 SF
                  state-of-the-art build- to-suit Class A offices for young
                  professionals seeking an opportunity to invest in their
                  professional future.
                </p>
              </div>
            </div>
          </section>
          <section className="flex-col justify-center w-full md:flex ">
            <div className="w-full px-4 max-w-[1000px] grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4 mx-auto mb-8 md:mb-16">
              {Object.entries(buttonLabels).map(([buttonName, label]) => (
                <button
                  key={buttonName}
                  onClick={imageButtonClick}
                  name={buttonName}
                  className={`${getButtonClass(
                    buttonName
                  )} w-full max-w-[200px] text-sm sm:text-base px-2 py-2 sm:px-4 sm:py-2`}
                >
                  Floor {label}
                </button>
              ))}
            </div>
            <div className="w-full relative">
              <p className="absolute top-2 md:top-6 left-1/2 transform -translate-x-1/2 text-lg md:text-2xl font-bold text-[#ad885d] bg-none px-4 py-2 rounded-md">
                Floor {buttonLabels[selectedButton]}
              </p>
              <img
                src={`img/resources/floor_pans/${selectedButton}.jpg`}
                className="w-full md:w-[70%] mx-auto max-w-[900px]"
                alt={`Floor plan for ${buttonLabels[selectedButton]}`}
              />
            </div>
          </section>
          <div className="w-full max-w-[1000px] mx-auto px-[20px] md:px-[50px] pt-[20px] md:pt-[50px] pb-[50px]">
            <div className="max-w-full overflow-x-auto">
              <table className="w-full border-collapse">
                <thead>
                  <tr className="border-b-2 border-black">
                    {TABLE_HEAD.map((head) => (
                      <th
                        key={head}
                        className="py-4 px-4 text-left font-medium text-black"
                      >
                        {head}
                      </th>
                    ))}
                  </tr>
                </thead>
                <tbody>
                  {floorData &&
                    floorData.map((item, index) => (
                      <tr key={index} className="border-b border-gray-300">
                        <td className="pt-4 pb-2  px-4">
                          <p className="text-black"> {item.floorNumber}</p>
                        </td>
                        <td className="px-4 pt-4 pb-2 ">
                          <p className="text-black">{item.unitNumber}</p>
                        </td>
                        <td className="px-4 pt-4 pb-2 ">
                          <p className="text-black">{item.SQFT}</p>
                        </td>
                        <td className="px-4 pt-4 pb-2 ">
                          <p
                            className={`text-md font-medium ${
                              item.Status === "Available"
                                ? "text-[#10b981]"
                                : "text-[#ef4444]"
                            }`}
                          >
                            {item.Status}
                          </p>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
